__turbopack_context__.v({
  "loading": "pageloading-module-scss-module__NvR_wq__loading",
  "pageLoadOverlay": "pageloading-module-scss-module__NvR_wq__pageLoadOverlay",
});
